import React from "react";
import "./contact.css";

function Contact() {
  return (
    <div className="contact-us">
      <div className="contact-info">
        <p>
          <span>Kitchen</span> : +91 89517 52351
        </p>
        <p>
          <span>Operations</span> : +91 99802 84000
        </p>
        <p>
          <span>Email ID</span>{" "}
          <a href="mailto:madhwapaaka@gmail.com"> : madhwapaaka@gmail.com</a>
        </p>
        <p>
          <span>Operating Address</span> : 181, 1st A Cross Rd, 2nd Phase, 4th
          Block, Banashankari 3rd Stage, Banashankari, Bengaluru, Karnataka
          560085
        </p>
      </div>
    </div>
  );
}

export default Contact;
